function apply() {
    Object.filter = (obj, predicate) =>
        Object.keys(obj)
            .filter( key => predicate(obj[key]) )
            .reduce( (res, key) => (res[key] = obj[key], res), {} );

    Array.removeWhere = (arr, callback) => {
        let i = 0;
        while (i < arr.length) {
            if (callback(arr[i])){
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
    }
}

export default apply
